import * as React from 'react';

import SignOthers32 from './SignOthers32';

export const signOthers32 = () => <SignOthers32 />;

export default {
    title: 'Icon/Fill/SignOthers32',
    component: SignOthers32,
    parameters: {
        notes: "`import SignOthers32 from 'box-ui-elements/es/icon/fill/SignOthers32';`",
    },
};
